import { isAfter } from 'date-fns';
import { t } from 'i18next';

export const nameMonths = [
    t('january'),
    t('february'),
    t('march'),
    t('april'),
    t('may'),
    t('june'),
    t('july'),
    t('august'),
    t('september'),
    t('octuber'),
    t('november'),
    t('december'),
];

export const weekDay = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

export const allMonths: string[] = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

export function dateToMonth(month: string) {
    const short: { [key: string]: string } = {
        '01': t('januaryShort'),
        '1': t('januaryShort'),
        '02': t('februaryShort'),
        '2': t('februaryShort'),
        '03': t('marchShort'),
        '3': t('marchShort'),
        '04': t('aprilShort'),
        '4': t('aprilShort'),
        '05': t('mayShort'),
        '5': t('mayShort'),
        '06': t('juneShort'),
        '6': t('juneShort'),
        '07': t('julyShort'),
        '7': t('julyShort'),
        '08': t('augustShort'),
        '8': t('augustShort'),
        '09': t('septemberShort'),
        '9': t('septemberShort'),
        '10': t('octuberShort'),
        '11': t('novemberShort'),
        '12': t('decemberShort'),
    };
    return short[month];
}

export function shortWeekDay(longDay: string) {
    let result: string = '';
    switch (longDay) {
        case 'Lunes' || 'lunes': {
            result = 'lun';
            break;
        }
        case 'Martes' || 'martes': {
            result = 'mar';
            break;
        }
        case 'Miércoles' || 'miercoles' || 'Miercoles' || 'miércoles': {
            result = 'mie';
            break;
        }
        case 'Jueves' || 'jueves': {
            result = 'jue';
            break;
        }
        case 'Viernes' || 'viernes': {
            result = 'vie';
            break;
        }
        case 'Sabado' || 'sábado' || 'Sábado' || 'sabado': {
            result = 'sab';
            break;
        }
        case 'Domingo' || 'domingo': {
            result = 'dom';
            break;
        }

        default: {
            break;
        }
    }
    return result || '';
}

export function dateToLongMonth(month: string) {
    const long: { [key: string]: string } = {
        '01': t('january'),
        '02': t('february'),
        '03': t('march'),
        '04': t('april'),
        '05': t('may'),
        '06': t('june'),
        '07': t('july'),
        '08': t('august'),
        '09': t('september'),
        '10': t('octuber'),
        '11': t('november'),
        '12': t('december'),
    };

    return long[month];
}

export function getStringCycle(cycleStarts: string, cycleEnds: string) {
    const init = new Date(cycleStarts);
    const end = new Date(cycleEnds);
    const startDay = init.getDate();
    const starMonth = init.getMonth() + 1;
    const endDay = init.getUTCDate();
    const endMonth = end.getMonth() + 1;

    const cicloInfo = `${t('clyceDetails')} ${startDay} ${dateToMonth(`${starMonth}`)} - ${endDay} ${dateToMonth(
        `${endMonth}`,
    )}`;

    return cicloInfo;
}

export function getFormatDate(
    date: Date | string,
    format:
        | 'DDDD'
        | 'DD MM'
        | 'DD de MM'
        | 'DD/MM/YYYY'
        | 'DD MMMM YYYY'
        | 'DD/MM'
        | 'DDDD 00, MMMM'
        | '00 MMMM'
        | '00:00'
        | 'MM YYYY',
) {
    const _date = new Date(date);

    const type: { [key: string]: string } = {
        'DD MM': `${_date.getDate()} ${dateToLongMonth(allMonths[_date.getMonth()])}`,
        'DD de MM': `${_date.getDate()} ${t('of')} ${dateToLongMonth(allMonths[_date.getMonth()])}`,
        'DD/MM/YYYY': `${String(new Date(_date).getDate()).padStart(2, '0')}/${String(
            new Date(_date).getMonth() + 1,
        ).padStart(2, '0')}/${_date.getFullYear()}`,
        'DD MMMM YYYY': `${_date.getDate()} ${dateToLongMonth(allMonths[_date.getMonth()])} ${_date.getFullYear()}`,
        'DD/MM': `${_date.getDate()}/${allMonths[_date.getMonth()]}`,
        '00 MMMM': `${_date.getDate()} ${dateToLongMonth(allMonths[_date.getMonth()])}`,
        '00:00 - 00s': `${_date.getHours()} - ${_date.getSeconds()}`,
        'DDDD 00, MMMM': `${weekDay[_date.getDay()]} ${_date.getDate()}, ${dateToLongMonth(
            allMonths[_date.getMonth()],
        )}`,
        DDDD: `${weekDay[_date.getDay()]}`,
        '00:00': `${new Date(_date).getHours()}:${String(new Date(_date).getMinutes()).padStart(2, '0')}`,
        'MM YYYY': `${dateToLongMonth(allMonths[_date.getMonth()])} ${_date.getFullYear()}`,
    };
    return date?.toString() !== 'Invalid Date' ? type[format] : '';
}

export const itsMoreThanXminutes = (date: string, minutes: number) => {
    const currentDate = new Date();
    const isMoreThanXMinutes = new Date(new Date(date).getTime() + minutes * 60000);

    return isAfter(currentDate, isMoreThanXMinutes);
};

export const compareCurrentDateWithEspecific = (day: number, month: number, year?: number) => {
    //day 1-31 month 0-11
    return new Date() < new Date(year || 2024, month, day);
};
